// src/services/transaction.service.js
import apiClient from './api.service';

class TransactionService {
  async getUserTransactions(userId) {
    const response = await apiClient.get(`/transactions/user/${userId}`);
    return response.data;
  }

  async getInvestmentTransactions(investmentId) {
    const response = await apiClient.get(`/transactions/investment/${investmentId}`);
    return response.data;
  }

  async createTransaction(userId, transactionData) {
    const response = await apiClient.post(`/transactions/user/${userId}`, {
      investmentId: transactionData.investmentId,
      transactionType: transactionData.type, // 'deposit' or 'withdrawal'
      amount: parseFloat(transactionData.amount),
      transactionDate: transactionData.date,
      description: transactionData.description || ''
    });
    return response.data;
  }

  async deposit(userId, depositData) {
    return this.createTransaction(userId, {
      ...depositData,
      type: 'deposit'
    });
  }

  async withdraw(userId, withdrawalData) {
    return this.createTransaction(userId, {
      ...withdrawalData,
      type: 'withdrawal'
    });
  }
}
const transactionService = new TransactionService();
export default transactionService;